// extracted by mini-css-extract-plugin
export default {"MenuItemBadge":"DesktopMenuItem_MenuItemBadge__s7FMS"};